import { useEffect } from 'react';
import { useTenantHasConfluence } from '@atlassian/jira-business-confluence-pages';
import { useIssueTypesAndFields } from '@atlassian/jira-business-entity-project';
import { getMissingFields } from '../../common/constants';
import { useBoardStore } from '../../services/board-store';
import { useColumns } from '../columns-old';
import { useFetchWorkflowsDetails } from '../workflow-old';
import type { BoardControllerReturn } from './types';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useBoardController = (): BoardControllerReturn => {
	useFetchWorkflowsDetails();
	const [{ issues, error }, { removeIssue, setIssueFields, setIssueTypes }] = useBoardStore();

	const hasConfluence = useTenantHasConfluence();

	const {
		data: { issueTypes, fields },
	} = useIssueTypesAndFields({
		issueOperation: 'VIEW',
	});

	const columns = useColumns();

	useEffect(() => {
		if (fields != null && issueTypes != null) {
			setIssueFields(fields.concat(getMissingFields(hasConfluence)));
			setIssueTypes(issueTypes);
		}
	}, [fields, hasConfluence, issueTypes, setIssueFields, setIssueTypes]);

	return {
		columns,
		issues,
		error,
		onRemoveIssue: removeIssue,
	};
};
